import React, { useEffect, useState } from "react";
import Repo from "./Repo";

function LabelsLoader() {
  const [labels, setLabels] = useState({});

  useEffect(() => {
    fetchLabels();
  }, []);

  const fetchLabels = async () => {
    try {
      const response = await Repo.getLabels();
      if (response.status === 200) {
        const data = await response.data;
        setLabels(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Resto del tuo codice...

  return labels;
}

export default LabelsLoader;
